import { render, staticRenderFns } from "./fileList.vue?vue&type=template&id=2ccc2b16&scoped=true"
import script from "./fileList.vue?vue&type=script&lang=js"
export * from "./fileList.vue?vue&type=script&lang=js"
import style0 from "./fileList.vue?vue&type=style&index=0&id=2ccc2b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccc2b16",
  null
  
)

export default component.exports